import { useBoolean, useMemoizedFn } from 'ahooks'
import {
  $getSelection,
  $isRangeSelection,
  FORMAT_TEXT_COMMAND,
  TextFormatType
} from 'lexical'

import { useEditor } from '../useEditor'
import { useSelectionChange } from '../useSelectionChange'

/**
 * 选中区域的格式
 */
export const useSelectionTextFormat = (name: TextFormatType) => {
  const editor = useEditor()
  const [format, formatActions] = useBoolean(false)

  const getSelectionFormatHandler = useMemoizedFn(() => {
    const selection = $getSelection()
    if ($isRangeSelection(selection)) {
      formatActions.set(selection.hasFormat(name))
    }
    return false
  })

  useSelectionChange(getSelectionFormatHandler)

  const toggleFormat = useMemoizedFn(() => {
    formatActions.toggle()
    editor.dispatchCommand(FORMAT_TEXT_COMMAND, name)
  })

  return [format, toggleFormat] as const
}
